import { NgModule } from '@angular/core';

import {SharedModule} from "../../shared/shared.module";
import {BemCombustivelApiService} from "./bem-combustivel-api.service";

@NgModule({
  imports: [
    SharedModule
  ],
  providers:[
    BemCombustivelApiService
  ],
  declarations: []
})
export class BemCombustiveisModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/bem-combustiveis/bem-combustiveis.module.ts
 **/